import { ClipboardIcon, LogOut, ChevronDown, Moon, Sun, Eye, EyeOff, Wallet,ExternalLink, HelpCircle } from "lucide-react";
import { useUser } from "@/context/UserContext";
import { handleLogoout, handleMetamaskSignIn, handleGoogleSignIn } from "@/services/auth";
import { GoogleLogin } from "@react-oauth/google";
import MMLogo from "@/assets/metamask-icon.webp";
import ChLogoDark from "@/assets/white.png";
import ChLogoLight from "@/assets/black.png";
import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { useTheme } from "@/context/ThemeProvider";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const navItems = [
  { label: "Home", path: "/dashboard", comingSoon: false },
  { label: "Funds", path: "/crates/view", comingSoon: false },
];

const MainHeader = () => {
  const { userInfo, setUserInfo, hidePortfolio, setHidePortfolio,currency,  setCurrency } = useUser();
  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { theme, setTheme } = useTheme();
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [showProfileModal, setShowProfileModal] = useState(false);

    const openArbiscan = (address: string) => {
    window.open(`https://arbiscan.io/address/${address}`, "_blank");
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !(dropdownRef.current as HTMLElement).contains(event.target as Node)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="bg-background  border-b border-border">
      <div className="max-w-7xl   mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
        <div className="flex-shrink-0 ">
          <img
            src={theme === "dark" ? ChLogoDark : ChLogoLight || "/placeholder.svg"}
            alt="ChLogo"
            className="h-8 w-auto  cursor-pointer"
            onClick={() => navigate("/dashboard")}
          />
        </div>

        <nav className=" md:flex items-center justify-center space-x-12">
          {navItems.map((item) => (
            <Link
              key={item.label}
              to={item.comingSoon ? "#" : item.path}
              className={`text-muted-foreground hover:text-primary transition-colors duration-200 ease-in-out ${
                item.comingSoon ? "cursor-not-allowed opacity-70" : ""
              }`}
              title={item.comingSoon ? "Coming Soon" : undefined}
            >
              <span className="font-medium">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3" ref={dropdownRef}>
          {userInfo.address ? (
            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-2 px-3 py-2 rounded-full hover:bg-muted transition-colors"
              >
                <div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center font-medium">
                  {userInfo.email ? userInfo.email.charAt(0).toUpperCase() : "U"}
                </div>
                <ChevronDown
                  className={`h-4 w-4 text-muted-foreground transition-transform duration-200 ${dropdownOpen ? "rotate-180" : ""}`}
                />
              </button>

              {/* {dropdownOpen && (
                <div className="absolute right-0 mt-2 w-64 bg-card rounded-lg shadow-lg border border-border overflow-hidden z-50">
                  <button
                    onClick={() => setShowProfileModal(true)}
                    className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 hover:bg-muted"
                  >
                    <Wallet className="h-4 w-4" />
                    <span>View Profile</span>
                  </button>
                  <button
                    onClick={() => setHidePortfolio(!hidePortfolio)}
                    className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 hover:bg-muted"
                  >
                    {hidePortfolio ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
                    <span>Toggle Private Mode</span>
                  </button>
                  <button
                    onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
                    className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 hover:bg-muted"
                  >
                    {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
                    <span>Toggle Theme</span>
                  </button>
                  <div className="px-4 py-2 border-t border-gray-200 dark:border-gray-700">
                        <p className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Currency</p>
                        <div className="flex space-x-2">
                          {["USD", "INR"].map((curr) => (
                            //
                            <button
                            key={curr}
                            onClick={() => setCurrency(curr as "USD" | "INR")}
                            className={`px-2 py-1 text-xs rounded focus:outline-none ${
                              currency === curr 
                                ? "bg-gray-400"
                                : ""
                            }`}
                          >
                            {curr}
                          </button>            
                          ))}
                        </div>
                      </div>
                  <div className="px-4 py-2 text-sm text-green-500 flex items-center space-x-2 border-t border-gray-200 dark:border-gray-700">
                    <Wallet className="h-4 w-4" />
                    <span>Wallet Connected</span>
                  </div>  
                  <button
                    onClick={() => handleLogoout(setUserInfo)}
                    className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 text-destructive hover:bg-destructive/10"
                  >
                    <LogOut className="h-4 w-4" />
                    <span>Logout</span>
                  </button>
                </div>
              )} */}
              {dropdownOpen && (
  <div className="absolute right-0 mt-2 w-64 bg-card rounded-lg shadow-lg border border-border overflow-hidden z-50">
    <button
      onClick={() => setShowProfileModal(true)}
      className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 hover:bg-muted"
    >
      <Wallet className="h-4 w-4" />
      <span>View Profile</span>
    </button>
    <button
      onClick={() => setHidePortfolio(!hidePortfolio)}
      className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 hover:bg-muted"
    >
      {hidePortfolio ? <Eye className="h-4 w-4" /> : <EyeOff className="h-4 w-4" />}
      <span>Toggle Private Mode</span>
    </button>
    <button
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 hover:bg-muted"
    >
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      <span>Toggle Theme</span>
    </button>

    {/* Currency Selection */}
    <div className="px-4 py-2 border-t border-gray-200 dark:border-gray-700">
      <p className="text-sm font-medium text-gray-700 dark:text-gray-200 mb-2">Currency</p>
      <div className="flex space-x-2">
        {["USD", "INR"].map((curr) => (
          <button
            key={curr}
            onClick={() => setCurrency(curr as "USD" | "INR")}
            className={`px-2 py-1 text-xs rounded focus:outline-none ${
              currency === curr ? "bg-gray-400" : ""
            }`}
          >
            {curr}
          </button>
        ))}
      </div>
    </div>

    {/* Wallet Connected */}
    <div className="px-4 py-2 text-sm text-green-500 flex items-center space-x-2 border-t border-gray-200 dark:border-gray-700">
      <Wallet className="h-4 w-4" />
      <span>Wallet Connected</span>
    </div>  

    {/* Help Button */}
    <button
      onClick={() => window.open("https://mail.google.com/mail/?view=cm&fs=1&to=contact@coinharbour.xyz", "_blank")}
      className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 text-blue-500 hover:bg-blue-500/10"
    >
      <HelpCircle className="h-4 w-4" />
      <span>Help & Support</span>
    </button>

    {/* Logout Button */}
    <button
      onClick={() => handleLogoout(setUserInfo)}
      className="w-full px-4 py-2 text-sm text-left flex items-center gap-2 text-destructive hover:bg-destructive/10"
    >
      <LogOut className="h-4 w-4" />
      <span>Logout</span>
    </button>
  </div>
)}

            </div>
          ) : (
            <div className="flex items-center gap-3">
              <div className="hidden sm:block">
                <GoogleLogin onSuccess={(credentialResponse) => handleGoogleSignIn(credentialResponse, setUserInfo)} />
              </div>
              <button
                onClick={() => handleMetamaskSignIn(setUserInfo)}
                className="flex items-center justify-center p-2 rounded-full hover:bg-muted transition-colors"
              >
                <img src={MMLogo || "/placeholder.svg"} alt="MetaMask" className="h-5 w-5" />
              </button>
            </div>
          )}
        </div>
      </div>

      <Dialog
                open={showProfileModal}
                onOpenChange={setShowProfileModal}
              >
                <DialogContent className="sm:max-w-md">
                  <DialogHeader className="relative">
                    <DialogTitle className="text-xl font-semibold">
                      Profile Details
                    </DialogTitle>
                  </DialogHeader>
                  <div className="space-y-6 py-4">
                    {userInfo.email && (
                      <div className="space-y-2">
                        <label className="text-sm font-medium text-muted-foreground">
                          Email
                        </label>
                        <div className="flex items-center justify-between bg-secondary/50 rounded-lg p-3">
                          <span className="truncate text-sm">
                            {userInfo.email}
                          </span>
                          <button
                            onClick={() =>
                              navigator.clipboard.writeText(userInfo.email)
                            }
                            className="ml-2 text-muted-foreground hover:text-primary"
                            aria-label="Copy email to clipboard"
                          >
                            <ClipboardIcon className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                    )}
                    {userInfo.address && (
                      <div className="space-y-2">
                        <label className="text-sm font-medium text-muted-foreground">
                          Ethereum Address
                        </label>
                        <div className="flex items-center justify-between bg-secondary/50 rounded-lg p-3">
                          <span className="truncate text-sm">
                            {userInfo.address}
                          </span>
                          <div className="flex items-center gap-2">
                            <button
                              onClick={() => openArbiscan(userInfo.address)}
                              className="text-muted-foreground hover:text-primary"
                              aria-label="View on Arbiscan"
                            >
                              <ExternalLink className="h-4 w-4" />
                            </button>
                            <button
                              onClick={() =>
                                navigator.clipboard.writeText(userInfo.address)
                              }
                              className="text-muted-foreground hover:text-primary"
                              aria-label="Copy address to clipboard"
                            >
                              <ClipboardIcon className="h-4 w-4" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    <button
                      onClick={() => {
                        handleLogoout(setUserInfo);
                        setShowProfileModal(false);
                      }}
                      className="w-full flex items-center justify-center gap-2 bg-red-500/10 hover:bg-red-500/20 text-red-500 rounded-lg py-3 transition-colors"
                    >
                      <LogOut className="h-5 w-5" />
                      <span>Logout</span>
                    </button>
                  </div>
                </DialogContent>
              </Dialog>
    </header>
  );
};

export default MainHeader;

